import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ElevateIcons } from '@hg-akademie-ban/ban-ui-assets/icons';
import * as DialogPrimitive from '@radix-ui/react-dialog';

import { cn } from '~ai-tutor/lib/utils';

import { Button } from './button';

function Dialog({ children, ...props }: React.ComponentProps<typeof DialogPrimitive.Root>) {
  return (
    <DialogPrimitive.Root data-slot="dialog" {...props}>
      {children}
    </DialogPrimitive.Root>
  );
}

function DialogTrigger({ children, ...props }: React.ComponentProps<typeof DialogPrimitive.Trigger>) {
  return (
    <DialogPrimitive.Trigger asChild data-slot="dialog-trigger" {...props}>
      {children}
    </DialogPrimitive.Trigger>
  );
}

function DialogPortal({ children, ...props }: React.ComponentProps<typeof DialogPrimitive.Portal>) {
  return (
    <DialogPrimitive.Portal data-slot="dialog-portal" {...props}>
      {children}
    </DialogPrimitive.Portal>
  );
}

function DialogOverlay({ className, ...props }: React.ComponentProps<typeof DialogPrimitive.Overlay>) {
  return (
    <DialogPrimitive.Overlay
      data-slot="dialog-overlay"
      className={cn(
        'bg-popover-foreground data-[state=open]:animate-overlayShow fixed inset-0 z-99 opacity-50',
        className,
      )}
      {...props}
    />
  );
}

function DialogTitle({ className, children, ...props }: React.ComponentProps<typeof DialogPrimitive.Title>) {
  return (
    <DialogPrimitive.Title data-slot="dialog-title" className={cn('mb-4 font-medium', className)} {...props}>
      {children}
    </DialogPrimitive.Title>
  );
}

function DialogContent({ className, ...props }: React.ComponentProps<typeof DialogPrimitive.Content>) {
  return (
    <DialogPrimitive.Content
      data-slot="dialog-content"
      className={cn(
        'bg-popover data-[state=open]:animate-contentShow fixed top-1/2 left-1/2 z-100 max-h-[85vh] w-[90vw] max-w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-md p-[25px] shadow-[var(--shadow-6)] focus:outline-none',
        className,
      )}
      {...props}
    />
  );
}

function DialogClose({ ...props }: React.ComponentProps<typeof DialogPrimitive.Close>) {
  return (
    <DialogPrimitive.Close data-slot="dialog-close" asChild {...props}>
      <Button
        variant="outline"
        className="absolute top-5 right-5 inline-flex size-[25px] cursor-pointer appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
        aria-label="Close"
      >
        <FontAwesomeIcon icon={ElevateIcons.solid.faClose} />
      </Button>
    </DialogPrimitive.Close>
  );
}

export { Dialog, DialogClose, DialogContent, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };
